export default {"src":"/_next/static/media/icon_reward_calendar_info_timer.d243aa7f.svg","height":12,"width":12,"blurWidth":0,"blurHeight":0};